import { ILoggingService } from "../../services";

//base class for all analytics events - no common properties yet
abstract class AnalyticsEvent {

    convertToGTMEvent(logger: ILoggingService) {
        const rawValues = Object.assign({}, this);
        for (const [key, value] of Object.entries(rawValues)) {
            const valueAsString = new String(value);
            if (valueAsString.length > 100) {
                rawValues[key] = valueAsString.substring(0, 100);
                logger.LogError("Analytics event truncated at 100 characters. Key=" + key + ", original value= " + value);
            }
        }
        return rawValues;
    }
}
export { AnalyticsEvent }